import {
  AdminInput,
  Button,
  ErrorToast,
  Modal,
  PropsModal,
  SuccessToast,
  rejectVerificationAgent,
  reportError,
} from '@vgrubs/components';
import { useState } from 'react';
import { useNavigate } from 'react-router';

export const RejectModalAgent = ({
  modalIsOpen,
  closeModal,
  setLoading,
}: PropsModal & {
  modalIsOpen: string | number;
}) => {
  const [reason, setReason] = useState('');
  const navigate = useNavigate();

  const id = modalIsOpen;

  async function handleRejectAgent() {
    if (!reason) return ErrorToast('Please enter a reason.');

    try {
      setLoading?.(true);
      const { data } = await rejectVerificationAgent(id, reason);
      SuccessToast(data.message);
      closeModal?.();
      navigate(-1);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading?.(false);
    }
  }

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Reject Agent"
    >
      <AdminInput
        type="textarea"
        placeholder="Enter rejection reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />

      <Button $selected $w="100%" $mt="40" onClick={handleRejectAgent}>
        Save
      </Button>
    </Modal>
  );
};
